import React, { useState } from 'react'
import deleteImg from '../../../images/Delete1.png';
import Lightbox from 'react-image-lightbox';

const UploadDocPreview = ({ handleRemoveClick, uploadDocpath, isRemove }) => {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <>
            {uploadDocpath ? (
                <>
                    {uploadDocpath.includes('.pdf') ? '' : <div className='commonNote text-left mb-1'>Please click on image for preview and zoom</div>}
                    {uploadDocpath.includes('.pdf') ? (
                        <div className='imgDisplayBlock pdfBlock'>
                            {isRemove ?
                                <div
                                    className='removeImgblock'
                                    onClick={handleRemoveClick}
                                >
                                    <img src={deleteImg} alt='' />
                                </div> : ''}
                            <div onClick={() => window.open(uploadDocpath, '_blank')} className="pdfLink">View PDF</div>
                        </div>
                    ) : (
                        <div className='imgDisplayBlock'>
                            {isRemove ? <div
                                className='removeImgblock'
                                onClick={handleRemoveClick}
                            >
                                <img src={deleteImg} alt='' />
                            </div> : ''}
                            <img
                                src={uploadDocpath}
                                className="img-fluid cursorPointer"
                                alt="imgUpload"
                                onClick={() => setIsOpen(true)}
                                style={{ maxHeight: '300px', objectFit: 'contain' }}
                            />

                            {isOpen && (
                                <Lightbox
                                    mainSrc={uploadDocpath}
                                    onCloseRequest={() => setIsOpen(false)}
                                />
                            )}
                        </div>
                    )}
                </>

            ) : ""
            }
        </>
    )
}

export default UploadDocPreview
